import React from "react";
import LegalLayout from "@/components/LegalLayout";
import { SITE } from "@/lib/site";

const PrivacyPolicy = () => {
  return (
    <LegalLayout
      title="Privacy Policy"
      effectiveDate="June 11, 2026"
      testIdRoot="privacy"
    >
      <p className="lead">Shadows of the Infinite respects reader privacy.</p>

      <p>
        This website is the public home for{" "}
        <em>Shadows of the Infinite: Echoes of Cinder</em>, a fictional
        science-fantasy universe created by Federico C. Quiñones.
      </p>

      <h2>Information We Collect</h2>
      <p>
        If you join the Cinder Archive email list, you may provide your email
        address and, if requested, your name or other signup details.
      </p>
      <p>
        The Cinder Archive signup is managed through MailerLite, a third-party
        email marketing provider. MailerLite may process signup information,
        consent records, email delivery data, and engagement data to help manage
        subscriptions and send emails.
      </p>
      <p>
        MailerLite’s Privacy Policy is available here:
        <br />
        <a
          href="https://www.mailerlite.com/legal/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="privacy-mailerlite-link"
          className="link-cinder"
        >
          https://www.mailerlite.com/legal/privacy-policy
        </a>
      </p>

      <h2>How We Use Information</h2>
      <p>
        Information submitted through the Cinder Archive signup may be used to
        send:
      </p>
      <ul>
        <li>launch updates</li>
        <li>behind-the-scenes updates</li>
        <li>fictional archive transmissions</li>
        <li>book and project news related to Shadows of the Infinite</li>
      </ul>
      <p>We do not sell subscriber information.</p>

      <h2>Unsubscribing</h2>
      <p>
        You may unsubscribe from Cinder Archive emails at any time by using the
        unsubscribe link included in MailerLite emails.
      </p>

      <h2>Contact</h2>
      <p>For privacy questions, contact:</p>
      <p>
        <a
          href={`mailto:${SITE.inquiriesEmail}`}
          data-testid="privacy-contact-email"
          className="link-cinder font-display italic text-xl"
        >
          {SITE.inquiriesEmail}
        </a>
      </p>

      <h2>Changes</h2>
      <p>
        This Privacy Policy may be updated as the website, email list, or
        launch infrastructure changes.
      </p>
    </LegalLayout>
  );
};

export default PrivacyPolicy;
